import React from 'react'
import { Topic } from 'services/ContentfulService/models/topics'
import { chooseAppropriateProduct, Product } from 'services/ContentfulService/models/product'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { BasicCrossSell } from 'components/layout'
import { TopicsSection } from './TopicsSection'
// import ProductsSection from 'experiences/learn/common/productsSection'
import { FAQ } from 'services/ContentfulService/models/fact'
import { FaqSection } from 'experiences/learn/common/FaqSection/FaqSection'
import { LearnContainer } from 'experiences/learn/common'
import { ApplySection } from 'experiences/learn/common/applySection'
import { TopicHero } from 'experiences/learn/topics/TopicHero'
import { PrioritizedContent } from 'experiences/shared/ContentfulImage/PriorityContext'
import { ArticleSection } from 'experiences/shared/ArticleSection'
import { ArticleCard } from 'experiences/learn/articles/ArticleCard'
import { truncArray } from 'lib'
import { CalculatorPreviewTile } from './CalculatorPreviewTile'
import { FionaTopics } from 'parameters/general'
import { CalculatorPreviewTileData } from './CalculatorPreviewTile/DebtConsolidationData'

interface Props {
	topic: Topic
	relatedTopics: Topic[]
	relatedProducts: Product[]
	featuredArticle?: ArticleSummary
	topArticles: ArticleSummary[]
	faqs: FAQ[]
}

export const TopicDetailPage = ({ topic, relatedTopics, featuredArticle, topArticles, faqs }: Props): JSX.Element => {
	return (
		<div>
			<TopicHero
				asset={topic.graphic}
				title={topic.name}
				subtitle={topic.subtitle}
				breadcrumbs={[
					{ name: 'Learn', url: '/learn' },
					{ name: 'Topics', url: '/learn/topics' }
				]}
			/>
			<LearnContainer>
				{
					//TODO: change once this is in CMS
					topic.slug === FionaTopics.DebtConsolidation ? (
						<CalculatorPreviewTile {...CalculatorPreviewTileData} />
					) : (
						<div>
							<PrioritizedContent>
								{featuredArticle && <ArticleCard mode={'cover'} article={featuredArticle} />}
							</PrioritizedContent>
						</div>
					)
				}
				{topArticles && topArticles.length > 1 && (
					<ArticleSection
						title="Top Articles"
						articles={truncArray(topArticles, 3)}
						linkTo={`${topic.relativePath}/articles`}
					/>
				)}
				<TopicsSection title="Related Topics" topics={relatedTopics} />
				<BasicCrossSell product={chooseAppropriateProduct({ topics: [topic] })} />
				<FaqSection faqs={faqs} />
			</LearnContainer>
			<ApplySection />
		</div>
	)
}
